import React from "react";
import { Link } from "react-router-dom";
import EmployeeRetentionImage from "../../assets/hiring_quide/employee-retention.webp";
import LeftVector from "../../assets/faq/left-Patterns.svg";
import RightVector from "../../assets/faq/right-element.svg";
import RightTalentPoolImage from "../../assets/hiring_quide/right_talent_pool.webp";
import BestWayToHireBlueCollar from "../../assets/hiring_quide/best-way-to-hire-blue-collar.webp";

const hiringGuide = [
    {
        note: "For Employers",
        title: "Forget 3 Months — Employee Retention Is Decided in Just 7 Days",
        like: "/employee-retention",
        message:
            "7-Day Test is a simple yet powerful way to understand whether a new hire is likely to stay.",
        image: EmployeeRetentionImage,
        duration: "3 mins read",
        date: "26 Sep 25",
    },
    {
        note: "For Employers",
        title:
            "Why MSMEs Struggle to Hire Blue-Collar Workers (and How to Fix It in 2026)",
        like: "/why-msmes-struggle-to-hire-blue-collar",
        message:
            "Running a business is never easy—especially when it comes to hiring the right people.",
        image: RightTalentPoolImage,
        duration: "5 mins read",
        date: "04 Sep 25",
    },
    {
        note: "For Employers",
        title: "Best Way to Hire Blue-Collar Workers in India",
        like: "/best-way-to-hire-blue-collar",
        message:
            "The best way to hire blue-collar workers in India is to use an omnichannel approach—combining digital and on-ground sourcing through platforms like Kaigal.",
        image: BestWayToHireBlueCollar,
        duration: "5 mins read",
        date: "27 Mar 26",
    },
];

const HiringGuide = () => {
    return (
        <div className="relative">
            {/* Background patterns */}
            <img
                src={LeftVector}
                alt="Left background"
                className="absolute top-0 left-0 w-80 md:w-49 lg:w-[300px] pointer-events-none opacity-50"
            />
            <img
                src={RightVector}
                alt="Right background"
                className="absolute bottom-0 right-0 w-80 md:w-96 lg:w-[300px] pointer-events-none opacity-50"
            />

            {/* Blog cards */}
            <div className="mx-auto max-w-4xl px-4 pt-16 md:pt-32 pb-16 relative z-10">
                {hiringGuide.map((post, index) => (
                    <div
                        key={index}
                        className="overflow-hidden rounded-xl bg-white shadow-md md:max-w-2xl mx-auto mb-6"
                    >
                        {/* Mobile: stacked layout | Desktop: side-by-side */}
                        <div className="flex flex-col sm:flex-row p-4 sm:p-8 gap-4 sm:gap-6">
                            {/* Image */}
                            <div className="flex-shrink-0">
                                <img
                                    className="w-full h-48 sm:w-36 sm:h-36 object-cover rounded-md"
                                    src={post.image}
                                    alt={post.title}
                                />
                            </div>

                            {/* Content */}
                            <div className="flex flex-col justify-between text-left">
                                {/* Meta info */}
                                <div className="text-sm text-gray-500">
                                    <span className="mr-2 font-medium text-gray-400">
                                        {post.note}
                                    </span>
                                    • <span className="ml-2">{post.duration}</span>
                                </div>

                                {/* Title */}
                                <Link
                                    to={post.like}
                                    className="mt-2 block text-base sm:text-lg leading-tight font-semibold text-black hover:underline"
                                >
                                    {post.title}
                                </Link>

                                {/* Description */}
                                <p className="mt-2 text-gray-500 text-sm">{post.message}</p>

                                {/* Date */}
                                <div className="mt-2 text-sm text-gray-500">{post.date}</div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default HiringGuide;
